var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ly_tempDefault"},[_c('layout-header'),(_vm.getAll.spinIsShow)?_c('modal-loading-spin'):_vm._e(),(_vm.getAll.error != null)?_c('modal-error'):_vm._e(),_c('main',{staticClass:"bl_main ly_main"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }